module.exports = __webpack_public_path__ + "img/syssy.1c622659.png";